var chunkMapping = {
	"0": [
		4651
	],
	"3": [
		4055,
		4585
	],
	"78": [
		5085
	],
	"163": [
		5172
	],
	"164": [
		5173
	],
	"167": [
		5176
	],
	"168": [
		5177
	],
	"169": [
		5178
	],
	"170": [
		5179
	],
	"171": [
		5180
	],
	"172": [
		5181
	],
	"173": [
		5182
	],
	"174": [
		5183
	],
	"175": [
		5184
	],
	"176": [
		5185
	],
	"177": [
		5186
	],
	"178": [
		5187
	],
	"179": [
		5188
	],
	"180": [
		5189
	],
	"181": [
		5190
	],
	"182": [
		5191
	],
	"183": [
		5192
	],
	"184": [
		5193
	],
	"185": [
		5194
	],
	"186": [
		5195
	]
};
var idToExternalAndNameMapping = {
	"4055": [
		"default",
		"./nuorder-components",
		3672
	],
	"4585": [
		"default",
		"./helios-components",
		3672
	],
	"4651": [
		"default",
		"./Containers",
		3582
	],
	"5085": [
		"default",
		"./OrderlessInvoices",
		3582
	],
	"5172": [
		"default",
		"./AsyncEventTracker",
		3582
	],
	"5173": [
		"default",
		"./HostWrapper",
		3582
	],
	"5176": [
		"default",
		"./CheckoutV3",
		3582
	],
	"5177": [
		"default",
		"./CheckoutConfirmation",
		3582
	],
	"5178": [
		"default",
		"./ContactCreditCards",
		3582
	],
	"5179": [
		"default",
		"./AuditDialog",
		3582
	],
	"5180": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3582
	],
	"5181": [
		"default",
		"./InvoiceDialog",
		3582
	],
	"5182": [
		"default",
		"./PaymentDueModal",
		3582
	],
	"5183": [
		"default",
		"./PaymentModal",
		3582
	],
	"5184": [
		"default",
		"./PaymentHistory",
		3582
	],
	"5185": [
		"default",
		"./PaymentConfigurations",
		3582
	],
	"5186": [
		"default",
		"./PaymentPreferences",
		3582
	],
	"5187": [
		"default",
		"./ManagePaymentProcessing",
		3582
	],
	"5188": [
		"default",
		"./MobilePaymentsWrapper",
		3582
	],
	"5189": [
		"default",
		"./PayPage",
		3582
	],
	"5190": [
		"default",
		"./Challenge",
		3582
	],
	"5191": [
		"default",
		"./ManagePaymentMethods",
		3582
	],
	"5192": [
		"default",
		"./LightspeedReports",
		3582
	],
	"5193": [
		"default",
		"./ActivateLightspeedPayments",
		3582
	],
	"5194": [
		"default",
		"./MarketingLandingPage",
		3582
	],
	"5195": [
		"default",
		"./ShippingPromotionsListContainer",
		3582
	]
};
var idToRemoteMap = {
	"4055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4585": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4651": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5085": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5172": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}